import { makeRequest } from "./client";

export type OpsClientEventKind =
  | "publish_client_failure"
  | "publish_validation_error"
  | "schedule_mutation_error"
  | "publish_now_error"
  | "other";

export const opsApi = {
  reportClientEvent: async (
    payload: {
      kind: OpsClientEventKind;
      path?: string;
      statusCode?: number;
      message?: string;
      noticeType?: string;
    },
    token: string
  ): Promise<void> => {
    try {
      await makeRequest("/v1/ops/client-events", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
    } catch {
      // Never block the user flow on telemetry.
    }
  },
};
